/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Draf_OkInputs */

const en_tut_draf_ok = /** @type {(inputs: Tut_Draf_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The draft appears with source quotes you can open one by one.`)
};

const id_tut_draf_ok = /** @type {(inputs: Tut_Draf_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draf muncul lengkap dengan kutipan sumber yang bisa dibuka satu per satu.`)
};

/**
* | output |
* | --- |
* | "The draft appears with source quotes you can open one by one." |
*
* @param {Tut_Draf_OkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_draf_ok = /** @type {((inputs?: Tut_Draf_OkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Draf_OkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_draf_ok(inputs)
	return en_tut_draf_ok(inputs)
});